import React from 'react';
import ProductItemView from '../ProductItemViewMobile';
import interoperability from '../../resource/middleware_mobile/interoperability.png';

const InteroperabilityMobile = () => {
    return (
        <ProductItemView
            title="Interoperabilidad"
            items={["Middleware funciona con un patrón de adapatadores, lo que nos permite conectarlo a cualquier sistema informático", "Podemos conectar los servicios/sistemas periféricos al LIS"]}
            image={interoperability}
            centered
            withGap />
    );
};

export default InteroperabilityMobile;